import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
// import './DropzoneType.css';

class DropzoneType extends Component {
  handleDrop = files => {
    this.props.handleSubmit(files[0]);
  };

  renderChildren = deets => {
    if (deets.isDragActive) {
      return (
        <div className="dropzone-content">
          <div className="content__line content__large drag-hover">
            WHAT'S IN THE BOX?!
          </div>
        </div>
      );
    } else if (deets.acceptedFiles.length) {
      return (
        <div className="dropzone-content accepted">
          <div className="content__line content__small">
            Received{' '}
            <span className={`highlight--token highlight--${this.props.type}`}>
              {this.props.type}
            </span>{' '}
            csv
          </div>
          <div className="content__line content__large">Nice job!</div>
        </div>
      );
    } else if (deets.rejectedFiles.length) {
      return (
        <div className="dropzone-content rejected">
          <div className="content__line">
            <span className="content__large highlight">Try again!</span>
          </div>
          <div className="content__line">(with a .CSV this time)</div>
        </div>
      );
    } else {
      return (
        <div className="dropzone-content">
          <div className="content__line content__small">
            <span className="content__large highlight">Click</span> or
          </div>
          <div className="content__line content__large highlight">
            drag<span className="content__small"> and </span>drop
          </div>
          <div className="content__line content__small">
            {this.props.type === 'BCH' || this.props.type === 'BTC'
              ? 'a '
              : 'an '}
            <span className={`highlight--token highlight--${this.props.type}`}>
              {this.props.type}
            </span>{' '}
            csv<span className="content__small"> file</span>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <Dropzone
        className="dropzone"
        activeClassName="dropzone-active"
        multiple={false}
        accept=".csv"
        onDrop={this.handleDrop}
      >
        {this.renderChildren}
      </Dropzone>
    );
  }
}

export default DropzoneType;



// WEBPACK FOOTER //
// ./src/DropzoneType.js